import auth from 'api/forgamers'
import * as types from '../mutation-types'
// let token = window.localStorage.getItem('accessToken')

export const fetchNews = ({ commit }, params) => {
  return auth.news(params).then((data) => {
    commit(types.FORGAMERS_NEWS, data)
    return Promise.resolve(data)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/forgamers/actions.js